module.exports = __webpack_public_path__ + "static/media/36_B.64e2c467.png";